import script from "./esPersonForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./esPersonForm.vue?vue&type=script&setup=true&lang=ts"

import "./esPersonForm.vue?vue&type=style&index=0&id=17f119a1&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17f119a1"]])

export default __exports__